import { render, staticRenderFns } from "./QuestionDetailsTab.vue?vue&type=template&id=51b63c19&scoped=true&"
import script from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b63c19",
  null
  
)

export default component.exports